/* eslint-disable no-param-reassign */
import produce from 'immer';
import initialState from 'redux/reducers/clonotypes/initialState';
var clonotypesError = produce(function (draft) {
  draft.loading = false;
  draft.error = true;
}, initialState);
export default clonotypesError;